import React, { useState, useEffect, useRef } from 'react';
import { Image, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { BiUserCircle } from 'react-icons/bi';
import { FiLogOut, FiMenu } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import PermissionContainer from '../../../Hocs/withPermission';
import { useWebProvider } from '../../../hooks/defaults/useWebProvider';
import scqlogo from '../../../img/teraprox-logo.png';
import { endPointSGM, ids, paths } from '../../../models/constantes';
import { setPageLocation } from '../../../Reducers/default-reducers/globalConfigReducer';
import { isAuthenticated } from '../../../Services/default/auth';
import "../../../styles/menuBarLogo.css";
import NotificationBell from '../Notifications/NotificationBell';

const MenuBar = () => {
  const { handleLogout, notificationSocket } = useWebProvider()
  const global = useSelector(state => state.global)
  const socket = global.socketConnection
  const dispatch = useDispatch()
  const otherNavigate = useNavigate()

  const [isMobile, setIsMobile] = useState(() => (typeof window !== 'undefined' ? window.innerWidth <= 768 : false))
  const [drawerOpen, setDrawerOpen] = useState(false)
  const drawerRef = useRef(null)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    // When drawer opens, prevent background scrolling
    if (drawerOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => { document.body.style.overflow = '' }
  }, [drawerOpen])

  useEffect(() => {
    if (!drawerOpen) return
    // focus on the first focusable element inside drawer
    const drawer = drawerRef.current
    const focusable = drawer ? drawer.querySelectorAll('a, button, input, select, textarea, [tabindex]') : []
    if (focusable && focusable.length) {
      focusable[0].focus()
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeDrawer()
        return
      }
      if (e.key === 'Tab' && drawer) {
        const focusables = Array.prototype.slice.call(drawer.querySelectorAll('a, button, input, select, textarea, [tabindex]')).filter(el => !el.disabled)
        if (!focusables.length) return
        const firstEl = focusables[0]
        const lastEl = focusables[focusables.length - 1]
        if (!e.shiftKey && document.activeElement === lastEl) {
          firstEl.focus()
          e.preventDefault()
        }
        if (e.shiftKey && document.activeElement === firstEl) {
          lastEl.focus()
          e.preventDefault()
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [drawerOpen])

  const navClickHandler = (event) => {
    const target = event.target
    if (target && target.classList && (target.classList.contains('dropdown-item') || target.classList.contains('drawer-link'))) {
      dispatch(setPageLocation(target.innerText || target.innerHTML))
      // close mobile drawer if the click originated from a mobile item
      if (drawerOpen) setDrawerOpen(false)
    }
  }

  const navigateToLogin = (eent) => {
    otherNavigate("Login")
  }

  const toggleDrawer = () => {
    setDrawerOpen(open => {
      // Se estiver abrindo o drawer, garantir que qualquer modal/offcanvas de notificações seja fechado
      if (!open) {
        // Fechar qualquer offcanvas de notificações que possa estar aberto
        const notificationOffcanvas = document.querySelector('.notification-offcanvas.show')
        if (notificationOffcanvas) {
          // Disparar evento de fechamento
          const closeButton = notificationOffcanvas.querySelector('.notification-close-button')
          if (closeButton) {
            closeButton.click()
          }
        }
      }
      return !open
    })
  }
  
  const closeDrawer = () => setDrawerOpen(false)

  const handleMobileLinkClick = (e) => {
    if (e && e.currentTarget) {
      const txt = e.currentTarget.innerText || e.currentTarget.innerHTML
      if (txt) dispatch(setPageLocation(txt))
    }
    closeDrawer()
  }

  const handleRedirectToManutencaoMobile = () => {
    closeDrawer()
    handleRedirectToManutencao()
  }

  const handleRedirectToManutencao = () => {
    // Codifica o token em base64 para passar na URL de forma mais segura
    //const encodedToken = btoa(global.token)
    // Redireciona para o outro frontend passando o token como parâmetro
    //removida adição de token temporariamente por promover o erro 413
    //const redirectUrl = `${endPointSGM}?token=${encodedToken}`
    const redirectUrl = endPointSGM
    // Abre em nova aba ou redireciona na mesma aba
    window.location.href = redirectUrl
  }

  if (isAuthenticated(global.token)) {
    return <>
      <div className='App tc f3 menu-bar'>
        <Navbar className="menu-bar" expand="lg" onClick={(event) => navClickHandler(event)} >
          {/* <NavItem style={{ marginRight: 20 }}>{version}</NavItem> */}
          <div className="navbar-logo">
            <Image style={{ cursor: "pointer" }} height={50} width={50} src={scqlogo} />
          </div>

          {/* Mobile specific hamburger toggle */}
          {isMobile ? (
            <div className="mobile-header-controls d-flex align-items-center gap-2">
              {/* Sino de notificações visível no topo (abre Offcanvas) */}
              <NotificationBell className="notification-bell" socket={notificationSocket} />

              {/* Botão do drawer */}
              <button className="mobile-menu-toggle" aria-label="Abrir menu" onClick={toggleDrawer}>
                <FiMenu size={22} color="#fff" />
              </button>
            </div>
          ) : (
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
          )}

          {/* Desktop collapse (hidden in mobile) */}
          {!isMobile && (
            <Navbar.Collapse id="basic-navbar-nav" >
              <Nav className="mr-auto" >
                <PermissionContainer
                  menubar
                  component={cRef => {
                    return (
                    <NavDropdown ref={cRef} className="teraprox-dropdown" title="Processo" id={ids.menuBar.processoDropdownMenu}>
                      <NavDropdown.Header>Engenharia</NavDropdown.Header>
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="dropdown-item" id={paths.processos} ref={componenteRef} to={paths.processos}>Processo</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="dropdown-item" id={paths.fluxos} ref={componenteRef} to={paths.fluxos}>Fluxo</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="dropdown-item" id={paths.operacoes} ref={componenteRef} to={paths.operacoes}>Operação</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="dropdown-item" id={paths.parametros} ref={componenteRef} to={paths.parametros}>Parâmetro</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="dropdown-item" id={paths.planosDeControle} ref={componenteRef} to={paths.planosDeControle}>Plano de Controle</Link>
                          )
                        }}
                      />
                      <NavDropdown.Divider />
                      <NavDropdown.Header>Controle de Processo</NavDropdown.Header>
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.cadernos} ref={componenteRef} className="dropdown-item" to={paths.cadernos}>Cadernos</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.C_E_P} ref={componenteRef} className="dropdown-item" to={paths.C_E_P}>CEP</Link>}
                      />
                     
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.analisePerformanceCp} ref={componenteRef} className="dropdown-item" to={paths.analisePerformanceCp}>Análise Performance</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.ordensDeCorrecao} ref={componenteRef} className="dropdown-item" to={paths.ordensDeCorrecao}>Ordens de Correção</Link>}
                      />
                       <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.materialConsumptionDashboard} ref={componenteRef} className="dropdown-item" to={paths.materialConsumptionDashboard}>Dashboard de Consumo de Materiais</Link>}
                      />
                      <NavDropdown.Divider />
                      <NavDropdown.Header>Cadastros</NavDropdown.Header>
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.recursos} ref={componenteRef} className="dropdown-item" to={paths.recursos}>Recursos</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.acoes} ref={componenteRef} className="dropdown-item" to={paths.acoes}>Ações</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.materiais} ref={componenteRef} className="dropdown-item" to={paths.materiais}>Materiais</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.unidades} ref={componenteRef} className="dropdown-item" to={paths.unidades}>Unidades</Link>}
                      />
                     
                    </NavDropdown>
                  )
                  }}
                />
                 
                {/* Menu Manutenção - Redireciona para outro frontend */}
                <PermissionContainer
                  menubar
                  component={cRef => {
                    return (
                      <NavDropdown ref={cRef} title="Manutenção" id={ids.menuBar.manutencaoDropdownMenu}>
                        <NavDropdown.Item 
                          onClick={() => handleRedirectToManutencao()}
                        >
                          Acessar Sistema de Manutenção
                        </NavDropdown.Item>
                      </NavDropdown>
                    )
                  }}
                />

              </Nav>
            </Navbar.Collapse>
          )}

          {/* Mobile drawer overlay */}
          {isMobile && (
            <>
              <div className={`mobile-drawer ${drawerOpen ? 'open' : ''}`} ref={drawerRef} role="dialog" aria-hidden={!drawerOpen} aria-label="Menu de navegação">
                <div className="mobile-drawer-header">
                  <div className="navbar-logo small">
                    <Image style={{ cursor: "pointer" }} height={36} width={36} src={scqlogo} />
                  </div>
                     
            <div className="company-name"><strong>{global.companyName}</strong></div>
            {/* <div className="dev-mode" hidden={!enviromentnode}> <h4> DEV-ON</h4></div> */}
            <div className="connection-status">{socket ? "Connected" : "Offline"}</div>

            <div className='d-flex align-items-center gap-3'>
              
              <Nav.Link href={paths.menu} title="Menu do Usuário">
                <BiUserCircle className="user-icon" size={24} />
              </Nav.Link>
              <Nav.Link onClick={() => handleLogout()} title="Sair">
                <FiLogOut size={22} />
              </Nav.Link>
            </div>
                  
          
                </div>
                <nav className="mobile-drawer-nav">
                  <div className="drawer-section">
                    <div className="drawer-section-title">Engenharia</div>
                     <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="drawer-link" id={paths.processos} ref={componenteRef} to={paths.processos}>Processo</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="drawer-link" id={paths.fluxos} ref={componenteRef} to={paths.fluxos}>Fluxo</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="drawer-link" id={paths.operacoes} ref={componenteRef} to={paths.operacoes}>Operação</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="drawer-link" id={paths.parametros} ref={componenteRef} to={paths.parametros}>Parâmetro</Link>
                          )
                        }}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => {
                          return (
                            <Link className="drawer-link" id={paths.planosDeControle} ref={componenteRef} to={paths.planosDeControle}>Plano de Controle</Link>
                          )
                        }}
                      />
                  </div>

                  <div className="drawer-divider" />

                  <div className="drawer-section">
                    <div className="drawer-section-title">Controle de Processo</div>
                   <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.cadernos} ref={componenteRef} className="drawer-link" to={paths.cadernos}>Cadernos</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.C_E_P} ref={componenteRef} className="drawer-link" to={paths.C_E_P}>CEP</Link>}
                      />
                     
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.analisePerformanceCp} ref={componenteRef} className="drawer-link" to={paths.analisePerformanceCp}>Análise Performance</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.ordensDeCorrecao} ref={componenteRef} className="drawer-link" to={paths.ordensDeCorrecao}>Ordens de Correção</Link>}
                      />
                  </div>

                  <div className="drawer-divider" />

                  <div className="drawer-section">
                    <div className="drawer-section-title">Cadastros</div>
                    <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.recursos} ref={componenteRef} className="drawer-link" to={paths.recursos}>Recursos</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.acoes} ref={componenteRef} className="drawer-link" to={paths.acoes}>Ações</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.materiais} ref={componenteRef} className="drawer-link" to={paths.materiais}>Materiais</Link>}
                      />
                      <PermissionContainer
                        menubar={true}
                        component={(componenteRef) => <Link id={paths.unidades} ref={componenteRef} className="drawer-link" to={paths.unidades}>Unidades</Link>}
                      />
                  </div>

                  <div className="drawer-divider" />

                

                  

                  <div className="drawer-section">
                    <div className="drawer-section-title">Ações</div>
                      <Link onClick={() => handleRedirectToManutencaoMobile()} className="drawer-link" to="#">Acessar Sistema de Manutenção</Link> 
                  </div>
                </nav>
              </div>

              <div className={`mobile-drawer-backdrop ${drawerOpen ? 'open' : ''}`} onClick={closeDrawer} />
            </>
          )}

         {!isMobile && (
           <Nav className="ms-auto align-items-center gap-3" >
            <NavItem className="company-name"><strong>{global.companyName}</strong></NavItem>
            {/* <NavItem className="dev-mode" hidden={!enviromentnode}> <h4> DEV-ON</h4></NavItem> */}
            <NavItem className="connection-status">{socket ? "Connected" : "Offline"}</NavItem>
            <NotificationBell className="notification-bell" socket={notificationSocket} />
            <NavItem >
              <Nav.Link href={paths.menu} title="Menu do Usuário">
                <BiUserCircle className="user-icon" size={24} />
              </Nav.Link>
            </NavItem>
            <NavItem>
              <Nav.Link onClick={() => handleLogout()} title="Sair">
                <FiLogOut size={22} />
              </Nav.Link>
            </NavItem>
          </Nav>
         )}
         
        </Navbar>
      </div>
    </>
  } else {
    return (
      <div className="menu-bar" >
        <Navbar className="menu-bar" expand="lg" onClick={(event) => navClickHandler(event)} >
          <div className="navbar-logo">
            <Image height={50} width={50} src={scqlogo} rounded />
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav"  >
            <Nav className="mr-auto" >
              <Link style={{ fontSize: "1.4rem" }} className="nav-link" to={"/Login"} onClick={() => navigateToLogin()}>Login</Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    )
  }
}

export default MenuBar;
